import React from 'react'
import { Menu, Dropdown } from 'antd'
import { connect } from 'react-redux'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'
import styles from './style.module.scss'

@withRouter // 啟用history
@connect(({ user }) => ({ user }))
@connect(({ settings }) => ({ settings }))
class ClinicSelector extends React.Component {
  state = {
    apiDataClinics: [],
  }

  componentDidMount() {
    console.log(this.props)
    this.fetchClinics()
  }

  changeClinic = ({ key }) => {
    // 選擇診所
    const { dispatch, history } = this.props
    console.log('trigger changeClinic')

    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'clinicId',
        value: key,
      },
    })

    // window.location.reload()
    history.push('/dashboard')
  }

  fetchClinics = () => {
    console.log(this.props)
    const apiHost = `${process.env.REACT_APP_API_URL}`
    const { user } = this.props
    let {
      settings: { clinicId },
    } = this.props

    fetch(`${apiHost}/api/adminWeb/admins/links`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`,
      }),
    })
      .then(response => {
        console.log(response)
        if (response.ok) {
          return response.json()
        }
        const error = new Error(response.statusText)
        error.response = response
        throw error
      })
      .then(data => {
        console.log('Success:', data)
        data.map(element => {
          element.selectText = `${element.clinic.name}` // add
          return element
        })
        this.setState({
          apiDataClinics: data,
        })

        // set default clinicId when login
        if (data && data.length > 0) {
          console.log('set default clinicId')
          if (clinicId == null) {
            // 沒有選過則預設選擇第1筆診所
            // eslint-disable-next-line prefer-destructuring
            clinicId = data[0].clinicId
            console.log(clinicId)
            this.changeClinic({ key: clinicId })
          } else {
            // 已有選過則檢查browser儲存的診所權限
            const selectedClinic = _.find(data, { clinicId })
            if (selectedClinic === undefined) {
              // 預設選擇第1筆診所
              // eslint-disable-next-line prefer-destructuring
              clinicId = data[0].clinicId
              console.log(clinicId)
              this.changeClinic({ key: clinicId })
            }
          }
        }
      })
      .catch(error => {
        console.error('Error:', error)
      })
  }

  render() {
    const {
      settings: { clinicId },
    } = this.props
    const { apiDataClinics } = this.state

    // get當前選擇的診所名稱
    const selectedClinic = _.find(apiDataClinics, { clinicId })
    const selectedName = selectedClinic ? selectedClinic.clinic.name : ''

    // 診所下拉選單
    const listItems1 = apiDataClinics.map(record => (
      <Menu.Item key={record.clinicId}>{record.selectText}</Menu.Item>
    ))
    const ClinicsMenu = (
      <Menu className={styles.menu} selectedKeys={[clinicId]} onClick={this.changeClinic}>
        {listItems1}
      </Menu>
    )

    return (
      <Dropdown overlay={ClinicsMenu} trigger={['click']}>
        <div className={styles.dropdown}>
          <strong>{selectedName}</strong>
        </div>
      </Dropdown>
    )
  }
}

export default ClinicSelector
